import { Lock } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { useCan } from './queries';

/**
 * Muestra el contenido solo si la membresía incluye el permiso. La API valida lo mismo en el
 * servidor (en el legacy el bloqueo era solo visual, mapa-vistas hallazgo 1).
 */
export function PermissionGate({
  permiso,
  modulo,
  children,
}: {
  permiso?: string;
  modulo: string;
  children: ReactNode;
}) {
  const puede = useCan(permiso);
  if (puede === undefined) return null;
  if (puede) return <>{children}</>;
  return (
    <section className="panel-vidrio mx-auto max-w-2xl text-center">
      <span className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-full bg-morado-700 text-white">
        <Lock size={24} />
      </span>
      <h1 className="text-2xl font-extrabold text-azul-texto">{modulo}</h1>
      <p className="mt-3 text-texto-2">
        Tu membresía actual no incluye <strong className="text-texto">{modulo}</strong>. Consulta
        las licencias disponibles para obtener acceso.
      </p>
      <Link to="/licencias" className="btn-cs btn-primario mt-6">
        Ver licencias
      </Link>
    </section>
  );
}
